import * as React from 'react';

type InfoIconProps = React.SVGProps<SVGSVGElement>;

const InfoIcon: React.FC<InfoIconProps> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1611_42677)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7 4C7 3.44772 7.44772 3 8 3C8.55229 3 9 3.44772 9 4C9 4.55228 8.55228 5 8 5C7.44772 5 7 4.55228 7 4ZM9 7V13H7V7H9Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_1611_42677">
        <rect width="16" height="16" />
      </clipPath>
    </defs>
  </svg>
);

export default InfoIcon;
